import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
export class EnvironmentService {
    private config: any;
    loaded = false;

    constructor(private httpClient: HttpClient) {
        
    }

    loadConfig(): Promise<any> {
        if (!this.loaded) {
            return fetch('./assets/config/config.json')
            .then(data => {
                return data.json();
            }).then(data => {
                // console.log(data)
                this.config = data;
                this.loaded = true;
                return data;
            });
        } else {
            return this.config;
        }
        
    }
    getConfig(key: string): any {
        return this.config[key];
    }
}